import Choices from "choices.js";

export default class Global {

    constructor() {
        this.initChoices();
        this.initPopup();
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {
            choices = new Choices(element);
        });
    }

    initPopup() {
        // Helper functions for cookies
        const setCookie = (name, value, days) => {
            let expires = "";
            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = `${name}=${value || ""}${expires}; path=/`;
        };

        const getCookie = (name) => {
            const nameEQ = `${name}=`;
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i].trim();
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
            }
            return null;
        };

        // Elements
        const popupOverlay = document.getElementById('popup-overlay');
        const popupClose = document.getElementById('popup-close');

        // Show the popup if the cookie is not set
        if (!getCookie('popupClosed') && popupOverlay) {
            popupOverlay.style.display = 'flex';
        }

        // Close popup on close button click
        if (popupClose) {
            popupClose.addEventListener('click', () => {
                popupOverlay.style.display = 'none';
                setCookie('popupClosed', 'true', 1); // Expires in 1 day
            });
        }

        // Close popup when clicking on the overlay (if clicking outside the popup content)
        if (popupOverlay) {
            popupOverlay.addEventListener('click', (e) => {
                if (e.target === popupOverlay) {
                    popupOverlay.style.display = 'none';
                    setCookie('popupClosed', 'true', 1);
                }
            });
        }
    }

}
